import {BrowserModule, Meta, provideClientHydration} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AuthGuardService} from './guards/auth-guard.service';
import {OuterPagesGuardService} from './guards/outer-pages-guard.service';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {TokenInterceptor} from './interceptors/token.interceptor';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {BaseUrlInterceptor} from './interceptors/base-url.interceptor';
import {MyContentModule} from './shared-components/my-content/my-content.module';
import {FooterModule} from './shared-components/footer/footer.module';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {MY_DATE_FORMATS} from './constants/general-variables';
import {SERVER_TOKEN} from './constants/tokens';
import {PublicListGuardService} from './guards/public-list-guard.guard';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MyContentModule,
    FooterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      progressBar: false,
      closeButton: true,
    }),
  ],
  providers: [
    AuthGuardService,
    PublicListGuardService,
    OuterPagesGuardService,
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true},
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS},
    {
      provide: SERVER_TOKEN,
      useFactory: () => {
        try {
          // @ts-ignore
          return global['serverToken'];
        } catch {
          return null;
        }
      },
    },
    provideClientHydration(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(meta: Meta) {
    // meta.addTag({
    //   property: 'og:title',
    //   content: `Test title - TheLysts`
    // });
    // meta.addTag({
    //   property: 'og:description ',
    //   content: `Test Description - TheLysts`
    // });
    // meta.addTag({
    //   property: 'og:image',
    //   content: 'assets/images/og-image.png'
    // });
    // seoHttpService.getLysts().then(r => {
    //   meta.addTag({
    //       property: 'seo:lysts',
    //       content: r
    //     });
    // });
  }
}
